/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespSimilarItem_viewer$ref = any;
export type PdpRespComplementaryItemsGrid_viewer$ref = any;
export type PdpRespComplementaryItemsGrid_viewer = {
    readonly " $fragmentRefs": PdpRespSimilarItem_viewer$ref;
    readonly " $refType": PdpRespComplementaryItemsGrid_viewer$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespComplementaryItemsGrid_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItem_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '64a3ea2779157c349a659e1aa0dcd062';
export default node;
